import * as $ from 'jquery';
import {Global} from "../init-global";
require("waypoints/lib/jquery.waypoints.js");


export class DisplayOnScroll
{
	protected $root: JQuery;
	protected triggerObj: Waypoint;

	constructor(elem: HTMLElement)
    {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI() {

        let offsetVal:string = (this.$root.hasClass('js-dsp-on-scroll--early')) ? '90%': '70%';

        if (typeof this.triggerObj != 'undefined') {
            this.triggerObj.destroy();
            this.reset();
        }

    	this.triggerObj = new Waypoint({
		  element: this.$root.get(0),
		  handler: (direction:any) => {
		  	this.$root.toggleClass('dsp-triggered', direction == 'down');
		  },
		  offset: offsetVal
		})
    }

    public reset() {
    	this.$root.removeClass('dsp-triggered');
    }
}